
<template>
  <div class="thumb-example">
    <!-- swiper1 -->
    <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
      <swiper-slide v-for="(item, index) in image" :key="index">
        <img :src="item.url" :alt="item.name">
      </swiper-slide>
      <div class="swiper-button-next swiper-button-white swiper-btn" slot="button-next"></div>
      <div class="swiper-button-prev swiper-button-white swiper-btn" slot="button-prev"></div>
    </swiper>
    <!-- swiper2 Thumbs -->
    <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
      <swiper-slide v-for="(item, index) in image" :key="index">
        <img :src="item.url" :alt="item.name">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    image: { type: Array }
  },
  name: 'swiper-example-thumbs-gallery',
  title: 'Thumbs gallery with Two-way control',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptionTop: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  }
}
</script>

<style lang="scss" scoped>
.swiper-button-next {
  right: 0px;
}
.swiper-button-prev {
  left: 0px;
}
.swiper-btn {
  outline: none;
  background: rgba($color: #000000, $alpha: .6);
}
.swiper-btn::after {
  font-size: 24px !important;
}

  .thumb-example {
    background-color: #e8e8e8;
    border: 1px solid #e8e8e8;
  }
  .swiper-slide img {
    width: 100%;
    /* height: 100%; */
  }
  .swiper-slide {
      background-size: cover;
      background-position: center;
    }
  .swiper {
    
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      border-top: 1px solid #e8e8e8;
      height: 20%;
      box-sizing: border-box;
      padding: 8px 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>